export const handleApiError = async (response: Response) => {
  try {
    const data = await response.json();
    return { status: response.status, data };
  } catch {
    return {
      status: response.status,
      message: response.statusText || "Unknown error",
    };
  }
};
